import { ethers } from 'ethers';
import { encodeFunctionData } from 'viem';

import { abiWallet } from '../config/abi.contract';
import useWrappedRPC from './useWrappedRPC';
import useEmbeddedWallet from './useEmbeddedWallet';
import { validatePurchaseTournamentTicketTransaction } from '../services/transaction.service';
import environments from '../utils/environments';

const { FRENZY_WALLET_CONTRACT_ADDRESS } = environments;

function useTicket() {
  const { sendTransactionWithGas } = useWrappedRPC();
  const { getEmbeddedWallet } = useEmbeddedWallet();

  const purchaseTournamentTicket = async (ethAmount, ticketQuantity) => {
    try {
      await getEmbeddedWallet();

      const value = ethers.utils.parseEther(ethAmount).toHexString();
      const data = encodeFunctionData({
        abi: abiWallet,
        functionName: 'buyTicket',
        args: [ticketQuantity],
      });

      const txUiConfig = {
        header: `Purchase ${ticketQuantity} ticket(s) for tournament`,
        description: `Send ${ethAmount} RON to owner for purchasing ${ticketQuantity} ticket(s)`,
        buttonText: `Send`,
      };

      // Construct transaction request
      const transactionRequest = {
        to: FRENZY_WALLET_CONTRACT_ADDRESS,
        data: data,
        value: value,
      };
      const txReceipt = await sendTransactionWithGas(transactionRequest, txUiConfig);
      if (!txReceipt) throw new Error('Transaction failed on blockchain');

      const backendResponse = await validatePurchaseTournamentTicketTransaction({ transactionHash: txReceipt.hash });

      return {
        success: true,
        message: 'Purchase ticket successful',
        data: backendResponse.data,
      };
    } catch (error) {
      console.error('Purchase ticket transaction failed:', error);
      return { success: false, message: error.message };
    }
  };

  return { purchaseTournamentTicket };
}

export default useTicket;
